var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy171(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M71.7,54.9L71.7,54.9c-0.4-6.3-5.6-11.3-12-11.3H39.5c-6.4,0-11.6,5-12,11.3l0,0l-2.2,30.6 c0,0.6,0.4,1,0.9,1.1c0.6,0,1-0.4,1.1-0.9h0L29.5,55l0,0c0.3-5.3,4.7-9.4,10-9.4h20.3c5.3,0,9.7,4.1,10,9.4l0,0l2.2,30.6 c0,0.6,0.5,1,1.1,0.9c0.6,0,1-0.5,0.9-1.1L71.7,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M62.3,60.7c-0.6,0-1,0.5-0.9,1.1l1.7,23.8c0,0.6,0.5,1,1.1,0.9c0.6,0,1-0.5,0.9-1.1l-1.7-23.8 C63.4,61.1,62.9,60.7,62.3,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M44.6,40.6c1.5,1.2,3.2,2,5,2c1.8,0,3.5-0.8,5-2c2.2-1.8,4-4.5,5.2-7.3c1.3-2.9,2-5.9,2-8.4 c0-6.8-5.5-12.2-12.2-12.2c-6.8,0-12.2,5.5-12.2,12.2c0,3.4,1.3,7.6,3.4,11.2C41.9,37.9,43.1,39.5,44.6,40.6z M42.4,17.6 c1.9-1.9,4.4-3,7.2-3c2.8,0,5.4,1.1,7.2,3c1.9,1.9,3,4.4,3,7.2c0,1.4-0.3,3.2-0.8,4.9c-0.8,2.7-2.2,5.5-3.9,7.5 c-0.8,1-1.8,1.9-2.7,2.4c-0.9,0.6-1.9,0.9-2.8,0.9c-1.3,0-2.5-0.5-3.7-1.5c-1.8-1.5-3.5-3.9-4.7-6.6c-1.2-2.6-1.8-5.5-1.8-7.6 C39.4,22.1,40.5,19.5,42.4,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M36.9,60.7c-0.6,0-1,0.4-1.1,0.9l-1.7,23.8c0,0.6,0.4,1,0.9,1.1c0.6,0,1-0.4,1.1-0.9l1.7-23.8 C37.8,61.2,37.4,60.8,36.9,60.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy171);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-171.46a64cc3ebc90936a27a4d1f778d2aad.svg";
export { ForwardRef as ReactComponent };